export const GUARDIAN_API = "https://content.guardianapis.com"

export const GUARDIAN_NEXT_GEN_API = "https://api.nextgen.guardianapps.co.uk"

export const CLOAPEDIA_API = "https://cloapedia-server.herokuapp.com/api/v1"
